<div
  class="cr-fe-field"
  [class.cr-fe-multiline]="multiline"
  [class.cr-fe-show-counter]="showCounter"
  [class.cr-fe-action-link]="type === 'action-link'"
>
  <!-- isPlainText left false (default) so existing formatting (bold, etc. -
       see the popup editor) still renders and isn't stripped by Quill's
       format whitelist; the toolbar is hidden purely via CSS below so it
       still looks like a plain input. -->
  <app-block-text
    *ngIf="!expanded"
    [blockData]="blockData"
    [placeholder]="placeholder"
    [maxLength]="maxLength"
    [type]="type"
    [variable]="variable"
    [blockId]="blockId"
    [isImage]="isImage"
    [selectedSegment]="selectedSegment"
    [canBeEmpty]="canBeEmpty"
    [segmentSelectV2]="true"
    (handleOnChange)="handleOnChange.emit($event)"
    (handleOnSegmentChange)="handleOnSegmentChange.emit($event)"
  ></app-block-text>

  <!-- Not shown for action-link fields - they carry their own segment
       dropdown in the same top-right corner (see the *-link-field grid
       overrides in each block's scss), so this button would sit on top of
       the dropdown's own chevron. A one-line URL has no real use for the
       bigger WYSIWYG popup anyway. -->
  <button
    type="button"
    class="cr-fe-popout-btn"
    *ngIf="!isImage && type !== 'action-link'"
    [disabled]="disabled"
    (click)="openExpanded()"
    title="Open popup editor"
    aria-label="Open popup editor"
  >
    <svg width="11" height="11" viewBox="0 0 20 20" fill="none">
      <path d="M6 14L14 6M14 6H8M14 6V12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</div>

<ng-container *ngIf="expanded">
  <div class="cr-fe-backdrop" (click)="expanded = false"></div>
  <div class="cr-fe-modal">
    <div class="cr-fe-modal-head">
      <div>
        <div class="cr-fe-modal-title">{{ placeholder }}</div>
        <div class="cr-fe-modal-subtitle">Expanded input editor</div>
      </div>
      <button type="button" class="cr-icon-btn" (click)="expanded = false" title="Close">
        <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
          <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
    <div class="cr-fe-modal-body">
      <app-block-text
        [blockData]="blockData"
        [placeholder]="placeholder"
        [maxLength]="maxLength"
        [type]="type"
        [variable]="variable"
        [blockId]="blockId"
        [isImage]="isImage"
        [selectedSegment]="selectedSegment"
        [canBeEmpty]="canBeEmpty"
        [isPlainText]="false"
        [segmentSelectV2]="true"
        (handleOnChange)="handleOnChange.emit($event)"
        (handleOnSegmentChange)="handleOnSegmentChange.emit($event)"
      ></app-block-text>
    </div>
    <div class="cr-fe-modal-footer">
      <button type="button" class="cr-btn cr-btn-secondary" (click)="expanded = false">Close</button>
      <button type="button" class="cr-btn cr-btn-primary" (click)="expanded = false">Done</button>
    </div>
  </div>
</ng-container>
